import React, { useState } from "react";
import { Alert, Autocomplete, Box, Button, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

const options = [
  { label: "True", value: true },
  { label: "False", value: false },
];
const CreateTenantModal = (props) => {

  const {openModal, handleCloseModal, handleAddTenant, tenantName, expirationDate, setTenantName, domainName, setDomainName, tenantStatus, setTenantStatus, setExpirationDate, setPrimaryStatus, primaryStatus} = props;
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!tenantName?.trim()) newErrors.tenantName = "Tenant name is required";
    if (!domainName?.trim()) newErrors.domainName = "Domain name is required";
    if (!tenantStatus) newErrors.tenantStatus = "Status is required";
    if (!expirationDate) {
      newErrors.expirationDate = "Expiration date is required";
    } else if (isNaN(new Date(expirationDate).getTime())) {
      newErrors.expirationDate = "Invalid expiration date";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateTenant = () => {
    if (validateForm()) {
      handleAddTenant();
    }
  };

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
        <Box style={{padding: '32px 0px !important', borderRadius: '4px', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "white", boxShadow: 24, p: 4, width: 700}}>
          <IconButton aria-label="close" onClick={handleCloseModal} sx={{position: "absolute", top: 8, right: 8, color: (theme) => theme.palette.grey[500]}}>
            <CloseIcon />
          </IconButton>
          <Typography id="create-tenant-modal" variant="h6" component="h2" gutterBottom sx={{fontWeight: '600', borderBottom: 1, borderColor: "divider", padding: '20px 32px'}}>
            Create Tenant
          </Typography>
          <Box sx={{padding: '20px 32px 32px 32px', display: 'flex', flexDirection: 'column'}}>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px', overflowY: 'auto', height: '54vh'}}>
            <Alert icon={<InfoIcon fontSize="inherit" />} severity="info" sx={{ bgcolor: '#e3f2fd', color: '#1565c0', fontWeight: '500', borderRadius: '4px', padding: '4px 16px', width: 'fit-content' }}>
              Tenant name should be unique. Once created cannot be edited later.
            </Alert>
            <Typography variant="inherit" component="h6" sx={{color: 'grey', fontWeight: '600'}}>
              Provide a name for Tenant.
            </Typography>
            <TextField label="Tenant Name" required variant="outlined" fullWidth value={tenantName} onChange={(e) => { setTenantName(e.target.value); setErrors((prev) => ({ ...prev, tenantName: "" })); }} error={!!errors.tenantName} helperText={errors.tenantName} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" } }}/>
            <Typography variant="inherit" component="h6" sx={{color: 'grey', fontWeight: '600'}}>
              Provide a domain name for Tenant.
            </Typography>
            <TextField label="Domain Name" required variant="outlined" fullWidth value={domainName} onChange={(e) => { setDomainName(e.target.value); setErrors((prev) => ({ ...prev, domainName: "" })); }} error={!!errors.domainName} helperText={errors.domainName} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" } }}/>
            <Typography variant="inherit" component="h6" sx={{color: 'grey', fontWeight: '600'}}>
              Choose status.
            </Typography>
            <FormControl required fullWidth sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" } }} error={!!errors.tenantStatus}>
              <InputLabel>Status</InputLabel>
              <Select label="Status" value={tenantStatus || "Active"} onChange={(e) => { setTenantStatus(e.target.value); setErrors((prev) => ({ ...prev, tenantStatus: "" })); }}>
              <MenuItem value="Active">Active</MenuItem>
              </Select>
              <FormHelperText>{errors.tenantStatus}</FormHelperText>
            </FormControl>
            <Typography variant="inherit" component="h6" sx={{color: 'grey', fontWeight: '600'}}>
               Primary Status
            </Typography>
            <Autocomplete
               options={options}
               getOptionLabel={(option) => option.label}
               value={options.find((opt) => opt.value === primaryStatus) || null}
               onChange={(event, newValue) => setPrimaryStatus(newValue?.value ?? null)}
               disableClearable
               renderInput={(params) => (
               <TextField
                {...params}
                label="Primary Status"
                variant="outlined"
                fullWidth
                sx={{ marginBottom: "16px" }}
              />
            )}
           />
            <Typography variant="inherit" component="h6" sx={{color: 'grey', fontWeight: '600'}}>
                Enter expiry date if applicable.
            </Typography>
            <TextField required label="Expiration Date" variant="outlined" type="date" fullWidth value={expirationDate} onChange={(e) => { setExpirationDate(e.target.value); setErrors((prev) => ({ ...prev, expirationDate: "" })); }} error={!!errors.expirationDate} helperText={errors.expirationDate} onBlur={() => { const today = new Date(); today.setHours(0, 0, 0, 0); const selectedDate = new Date(expirationDate); if (!expirationDate) { setErrors((prev) => ({ ...prev, expirationDate: "Expiration date is required", })); } else if (selectedDate < today) { setErrors((prev) => ({ ...prev, expirationDate: "Expiration date cannot be in the past", })); } }} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}} InputLabelProps={{shrink: true}} InputProps={{ inputProps: { min: new Date().toISOString().split("T")[0] } }}/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" onClick={handleCreateTenant} sx={{textTransform: 'capitalize', fontWeight: '600'}}>
                Create Tenant
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
  );
}

export default CreateTenantModal;